import {
  Avatar,
  Button,
  FormControl,
  makeStyles,
  Paper
} from "@material-ui/core";
import SettingsIcon from '@material-ui/icons/Settings';
import { DatePicker } from "@material-ui/pickers";
import withAdminLayout from "components/HoC/withAdminLayout";
import CertifyingAgency from "pages/admin/dashboard/components/certifyingAgency";
import CheckStatus from "pages/admin/dashboard/components/checkStatus";
import Endorsement from "pages/admin/dashboard/components/endorsement";
import Industry from "pages/admin/dashboard/components/industry";
import News from "pages/admin/dashboard/components/news";
import Notifications from "pages/admin/dashboard/components/notifications";
import RequestChart from "pages/admin/dashboard/components/requestChart";
import TypeOfVisaChart from "pages/admin/dashboard/components/typeOfVisaChart";
import VisaChart from "pages/admin/dashboard/components/visaChart";
import Webboard from "pages/admin/dashboard/components/webboard";
import { useState } from "react";
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';






const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  layout: {
    width: '100%',
    height: '100%'
  },
  setting: {
    cursor: 'pointer',
    display: "flex", justifyContent: "space-between",
    padding: "0px 10px"
  },
  rounded: {
    backgroundColor: "dimgray", width: "30px", height: "30px"
  },
  editMode: {
    display: "flex", alignItems: 'center'
  },
  editText: {
    marginRight: "15px", color: "#2dce98", fontWeight: "500", fontSize: "16px"
  },
  wrapChart: {
    borderRadius: "9px", boxShadow: "0 3px 17px 0 rgb(126 126 126 / 15%)", backgroundColor: "white", padding: 5
  },
  wrapFilter: {
    display: 'flex',
    marginBottom: 15
  }
}));

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const defaultlayout = [
  { i: 'a', x: 0, y: 0, w: 4, h: 5, isResizable: false },
  { i: 'b', x: 4, y: 0, w: 4, h: 5, isResizable: false },
  { i: 'c', x: 8, y: 0, w: 4, h: 5, isResizable: false },

  { i: 'd', x: 0, y: 4, w: 8, h: 5, isResizable: false },
  { i: 'e', x: 8, y: 4, w: 4, h: 5, isResizable: false },

  { i: 'f', x: 0, y: 9, w: 4, h: 5, isResizable: false },
  { i: 'g', x: 4, y: 9, w: 4, h: 5, isResizable: false },
  { i: 'h', x: 8, y: 9, w: 4, h: 5, isResizable: false },

  { i: 'i', x: 0, y: 14, w: 7, h: 5, isResizable: false },
  { i: 'j', x: 7, y: 14, w: 5, h: 5, isResizable: false },
];
const originalLayouts = getFromLS("layouts") || {};
// const originalLayouts = {};

function DashboardPage() {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);

  const [layout, setlayout] = useState(JSON.parse(JSON.stringify(originalLayouts)));


  const onLayoutChange = (layout, layouts) => {
    saveToLS("layouts", layouts);
    setlayout(layouts);
  }


  return (
    <Paper className={classes.paper}>
      {/* <AdminTitle
        title="Dashboard"
      // subTitle="Number of successful applicants by targeted industries"
      /> */}
      <div className={classes.setting}>
        <div className={classes.wrapFilter}>
          <FormControl variant="outlined" className={classes.formControl} style={{ marginRight: 10 }}>
            <DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              size="small"
              label="Start Date"
              views={["year", "month", "date"]}
            />
          </FormControl>
          <FormControl variant="outlined" className={classes.formControl} style={{ marginRight: 10 }}>
            <DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              size="small"
              label="End Date"
              views={["year", "month", "date"]}
            />
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.buttonViewDetail}

          >
            Search
          </Button>
        </div>
        {
          !editMode &&
          <Avatar variant="rounded" className={classes.rounded}>
            <SettingsIcon onClick={() => {
              setEditMode(true)
            }} />
          </Avatar>
        }
        {
          editMode &&
          <div className={classes.editMode}>
            <div className={classes.editText}>Edit Mode</div>
            <Button variant="contained" color="primary" size="small" className={classes.buttonViewDetail} onClick={() => {
              setEditMode(false)
              console.log(layout)
            }} >
              Save
            </Button>
          </div>
        }

      </div>
      <ResponsiveReactGridLayout
        className="layout"
        cols={{ lg: 12, md: 12, sm: 2, xs: 2, xxs: 2 }}
        rowHeight={30}
        layouts={layout}
        isDraggable={editMode}
        onLayoutChange={(layout, layouts) =>
          onLayoutChange(layout, layouts)
        }
      >
        <div className={classes.wrapChart} key="a" data-grid={defaultlayout[0]}>
          <VisaChart />
        </div>
        <div className={classes.wrapChart} key="b" data-grid={defaultlayout[1]}>
          <RequestChart />
        </div>
        <div className={classes.wrapChart} key="c" data-grid={defaultlayout[2]}>
          <TypeOfVisaChart />
        </div>

        <div className={classes.wrapChart} key="d" data-grid={defaultlayout[3]}>
          <CheckStatus />
        </div>
        <div className={classes.wrapChart} key="e" data-grid={defaultlayout[4]}>
          <CertifyingAgency />
        </div>

        <div className={classes.wrapChart} key="f" data-grid={defaultlayout[5]}>
          <News />
        </div>
        <div className={classes.wrapChart} key="g" data-grid={defaultlayout[6]}>
          <Notifications />

        </div>
        <div className={classes.wrapChart} key="h" data-grid={defaultlayout[7]}>
          <Webboard />
        </div>

        <div className={classes.wrapChart} key="i" data-grid={defaultlayout[8]}>
          <Endorsement />
        </div>
        <div className={classes.wrapChart} key="j" data-grid={defaultlayout[9]}>
          <Industry />
        </div>
      </ResponsiveReactGridLayout>


    </Paper >
  );
}

export default withAdminLayout(DashboardPage);


function getFromLS(key) {
  let ls = {};
  if (global.localStorage) {
    try {
      ls = JSON.parse(global.localStorage.getItem("rgl-8")) || {};
    } catch (e) {
      /*Ignore*/
    }
  }
  return ls[key];
}

function saveToLS(key, value) {
  if (global.localStorage) {
    global.localStorage.setItem(
      "rgl-8",
      JSON.stringify({
        [key]: value
      })
    );
  }
}